import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { PageEvent } from "@angular/material/paginator";
import { Observable, Subscription } from "rxjs";
import { VariedadService } from "../service/variedad.service";
import { ObservationService } from "../../observation/service/observation.service";
import { RespCountries, RespRegions } from "../model/variedad.model";
import { UserService } from "../../user/service/user.service";
import { map, startWith } from "rxjs/operators";
import { AuthService } from "../../auth/service/auth.service";

@Component({
  selector: "app-variedad-list-edit",
  templateUrl: "./variedad-list-edit.component.html",
  styleUrls: ["./variedad-list-edit.component.css"],
})
export class VariedadListEditComponent implements OnInit {
  constructor(private variedadService: VariedadService,
    private userService: UserService,
    private authService: AuthService) { }
  _showFirstLastButtons = true;
  _pageSizeOptions: number[] = [5, 20, 40, 60, 100, 500];
  page_control = 0;
  page_size_control = 5;
  _length = 100;

  cardContentList!: any;
  varietyVarietySubs$!: Subscription;



  filteredOptionsVariety!: Observable<any>;
  filteredOptionsUser!: Observable<any>;
  filteredOptionsCountry!: Observable<RespCountries>;
  filteredOptionsRegion!: Observable<RespRegions>;
  filteredOptionsVarietyGroup!: Observable<any>;

  varietal_group_value = 'Todos';
  country_value = 'Todos';
  is_original_value = 'Todos';
  observation_date_control = new FormControl();
  observation_date_start_control = new FormControl();
  observation_date_end_control = new FormControl();
  observation_date_months = new FormControl();
  user_id_control = new FormControl();
  farmer_control = new FormControl();
  user_control = new FormControl();
  variety_control = new FormControl();
  country_control = new FormControl();
  region_control = new FormControl();
  varietal_group_control = new FormControl();

  ngOnInit(): void {
    this.filteredOptionsCountry = this.variedadService.getCountries();
    this.filteredOptionsRegion = this.variedadService.getRegions('Perú');
    this.filteredOptionsVarietyGroup = this.variedadService.getVarietalGroups();
    this.filteredOptionsUser = this.userService.getUsers();
    this.filteredOptionsVariety = this.variety_control.valueChanges.pipe(
      startWith(""),
      map((_value) => this.fnSearchVarietyNames(_value))
    );



    this.fnSearchVariety();
  }

  fnSearchVarietyNames(variety_value: string): string[] {
    const _optionList: string[] = [];
    const _var = {
      page: 0,
      page_size: 100,
      variety_name: variety_value,
      country: null,
      region: null,
      varietal_group: null,
      // original_only: false,
      original_only: this.authService.isRole('ADMIN') ? false : true,
      is_original: null,
      user_id: null,
      created_date: null,
    };
    this.variedadService.getSearch(_var).subscribe((_resp: any) => {
      _resp.data.map((_element: any) => {
        _optionList.push(_element.variety_name);
      });
    });
    return _optionList;
  }


  handlePageEvent(event: PageEvent) {
    this.page_control = event.pageIndex;
    this.page_size_control = event.pageSize;
    this._length = event.length;
    this.fnSearchVariety();
  }


  fnSearchVariety() {
    let _user_id = null;
    if (this.user_control.value && this.user_control.value != '') {
      const _value: {
        user_id: number;
        username: any;
        first_name: any;
        last_name: any;
        image_url: string;
      } = this.user_control.value
      _user_id = _value.user_id;
    }



    const _var = {
      page: this.page_control,
      page_size: this.page_size_control,
      variety_name: this.variety_control.value,
      country: this.country_control.value,
      region: this.region_control.value,
      varietal_group: this.varietal_group_control.value,
      // original_only: false,
      original_only: this.authService.isRole('ADMIN') ? false : true,
      is_original: this.is_original_value == 'Todos' ? null : (this.is_original_value === 'Si' ? true : false),
      user_id: _user_id,
      created_date: null,
    };

    this.cardContentList = [];
    this.varietyVarietySubs$ = this.variedadService
      .getSearch(_var)
      .subscribe((_variedad: any) => {
        this._length = _variedad.pagination.total_count;
        _variedad.data.map((_element: any) => {
          this.cardContentList.push({
            species_id: _element.species_id,
            species_name: _element.species_name,
            synonyms: _element.synonyms,
            user_id: _element.user_id,
            user_image_url: _element.user_image_url,
            username: _element.username,
            variety_id: _element.variety_id,
            variety_image_url: _element.variety_image_url,
            variety_name: _element.variety_name,
            vs_id: _element.vs_id,
            is_original: _element.is_original,
          });
        });
      });
  }

  displayFnUser(_obj: any): string {
    return _obj && _obj.username ? _obj.username : '';
  }

  fnClearFilters() {
    this.varietal_group_value = 'Todos';
    this.country_value = 'Todos';
    this.is_original_value = 'Todos';

    this.observation_date_control.setValue(null);
    this.observation_date_start_control.setValue(null);
    this.observation_date_end_control.setValue(null);
    this.observation_date_months.setValue(null);
    this.user_id_control.setValue(null);
    this.farmer_control.setValue('');
    this.user_control.setValue(null);
    this.variety_control.setValue(null);
    this.country_control.setValue(null);
    this.region_control.setValue(null);
    this.varietal_group_control.setValue(null);
    this.variety_control.setValue(null);
    this.page_size_control = 5;
    // this.dialogData = {
    //   formAnyDate: true,
    //   formDate: null,
    //   formDateInit: null,
    //   formDateEnd: null,
    //   formSelected: null,
    //   formPersonId: null,
    //   formPersonValue: null,
    //   formSite: null,
    // };
    // this.badgeFilter = null;
    this.fnSearchVariety();
  }
}
